var $cb1dd951fa1efcbf$exports = {};
$cb1dd951fa1efcbf$exports = {
    "collapse": `\u{637}\u{64A}`,
    "expand": `\u{62A}\u{645}\u{62F}\u{64A}\u{62F}`
};


export {$cb1dd951fa1efcbf$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
